import { BsChevronRight, BsChevronLeft, BsFillDoorOpenFill } from "react-icons/bs";
import { TbChevronsUpRight, TbArrowBarToUp, TbArrowBarToDown } from "react-icons/tb";
import { ROOM_CONFIG } from "./roomConfig"; // adjust path
import SalzzeitMuseen from "../MuseenOverlay/SalzzeitMuseen";

import imageGalleryArchiv from "../EntryRoom/text/imageGalleryText.json";
import imageGalleryArchivEn from "../EntryRoom/text/imageGalleryText_en.json";
import infoTextArchiv from "../EntryRoom/text/entryRoomText.json";
import infoTextArchivEn from "../EntryRoom/text/entryRoomText_en.json";
import { stateNavigation, stateInArea, stateWallPush, stateDevice, stateIframeWindow, stateEnglisch, stateInAreaRooms } from "../store.jsx";
import * as THREE from "three";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useSnapshot } from "valtio";
import "../style.css";
import SlidebarImageGallery from "./SlidebarImageGallery.jsx";
import SlidebarImageGalleryBig from "./SlidebarImageGalleryBIg.jsx";
import Header from "./HeaderWaypoint.jsx";
import salzabbauTimebarState from "../Themes/Salzabbau/states/salzabbauTimebarState.js";
import handelswegeTimebarState from "../Themes/Handelswege/states/handelswegeTimebarState.js";
import menschenTimebarState from "../Themes/Menschen/states/menschenTimebarState.js";
import holzarbeitTimebarState from "../Themes/Holzarbeit/states/holzarbeitTimebarState.js";
import holzarbeitZeitmaschineTexte from "../Themes/Holzarbeit/states/holzarbeitZeitmaschineTexte.js";
import holzarbeitZeitmaschineTitel from "../Themes/Holzarbeit/states/holzarbeitZeitmaschineTitel.js";
import klimaTimebarState from "../Themes/Klima/states/klimaTimebarState.js";

// TTS-Sprachausgabe pro Info-Text (Id aus entryRoomText.json → MP3 in
// public/Sounds/TTS/). Fehlt ein Eintrag, erscheint kein Play-Button und es
// wird nichts geladen.
// DEAKTIVIERT für den aktuellen Build — die komplette Verdrahtung
// (TtsPlayButton, Prop-Durchreichung) bleibt bestehen. Zum Reaktivieren
// einfach wieder Einträge eintragen, z.B.:
//   StartInfo: "/Sounds/TTS/Startinfo.mp3",
const TTS_AUDIO_BY_INFO_ID = {};

const loadedRoomsCache = {};

async function loadRoom(roomId) {
  if (loadedRoomsCache[roomId]) return loadedRoomsCache[roomId];
  const config = ROOM_CONFIG[roomId];
  if (!config) {
    console.warn(`Unknown room id: ${roomId}`);
    return null;
  }
  const mod = await config.loader();
  const data = mod.default ?? mod;
  loadedRoomsCache[roomId] = data;
  return data;
}

function LandscapeCarousel({ filteredWps, filteredActiveIndex, waypointsVariable, onSelect, cameraAnimationRuns, isEnglisch }) {
  const SPACING = 170;
  const L = filteredWps.length;

  const [offset, setOffset] = useState(filteredActiveIndex);
  const noTransRef = useRef(false);
  const [tick, setTick] = useState(0);
  const prevAiRef = useRef(filteredActiveIndex);
  const trackRef = useRef(null);
  const viewportRef = useRef(null);
  const [vpWidth, setVpWidth] = useState(0);

  // Synchronous initial measurement before first paint
  useLayoutEffect(() => {
    if (viewportRef.current) {
      setVpWidth(viewportRef.current.getBoundingClientRect().width);
    }
  }, []);

  // Reset when waypoint set changes (L changes)
  useEffect(() => {
    noTransRef.current = true;
    setOffset(filteredActiveIndex);
    prevAiRef.current = filteredActiveIndex;
    requestAnimationFrame(() => { noTransRef.current = false; setTick((t) => t + 1); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [L]);

  // Sync offset when filteredActiveIndex changes (arrow clicks)
  useEffect(() => {
    if (L === 0) return;
    const prev = prevAiRef.current;
    const curr = filteredActiveIndex;
    let delta = curr - prev;
    if (Math.abs(delta) > L / 2) delta = delta > 0 ? delta - L : delta + L;
    if (delta !== 0) setOffset((o) => o + delta);
    prevAiRef.current = curr;
  }, [filteredActiveIndex, L]);

  useEffect(() => {
    const el = viewportRef.current;
    if (!el) return;
    const ro = new ResizeObserver((entries) => setVpWidth(entries[0].contentRect.width));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const center = L + offset;
  const trackX = vpWidth > 0 && L > 0 ? vpWidth / 2 - center * SPACING - SPACING / 2 : 0;

  const handleTransitionEnd = (e) => {
    if (e.target !== trackRef.current || L === 0) return;
    if (offset >= L || offset < 0) {
      const rebased = ((offset % L) + L) % L;
      noTransRef.current = true;
      setOffset(rebased);
      requestAnimationFrame(() => { noTransRef.current = false; setTick((t) => t + 1); });
    }
  };

  return (
    <div style={{ position: "relative", flex: 1, minHeight: "130px" }}>
      <div
        ref={viewportRef}
        style={{
          position: "absolute", top: 0, bottom: 0, left: 0, right: 0,
          overflow: "hidden",
          opacity: vpWidth > 0 && L > 0 ? 1 : 0,
          maskImage: "linear-gradient(90deg, transparent 0, #000 9%, #000 91%, transparent 100%)",
          WebkitMaskImage: "linear-gradient(90deg, transparent 0, #000 9%, #000 91%, transparent 100%)",
        }}
      >
        <div style={{ position: "absolute", top: "50%", left: 0, right: 0, height: "1px", background: "rgba(255,255,255,0.16)", transform: "translateY(-50%)" }} />
        {L > 0 && <div
          ref={trackRef}
          style={{
            position: "absolute", top: 0, left: 0, height: "100%",
            width: `${3 * L * SPACING}px`,
            transform: `translateX(${trackX}px)`,
            transition: noTransRef.current ? "none" : "transform 0.55s cubic-bezier(0.22,0.61,0.36,1)",
          }}
          onTransitionEnd={handleTransitionEnd}
        >
          {Array.from({ length: 3 * L }, (_, j) => {
            const wp = filteredWps[j % L];
            const ad = Math.abs(j - center);
            const scale = Math.max(0.5, 1 - 0.12 * ad);
            const opacity = ad > 4 ? 0 : Math.max(0, 1 - 0.24 * ad);
            const isActive = j === center;
            return (
              <div
                key={j}
                style={{
                  position: "absolute", top: 0, left: `${j * SPACING}px`,
                  width: `${SPACING}px`, height: "100%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  cursor: opacity < 0.12 ? "default" : "pointer",
                  pointerEvents: opacity < 0.12 ? "none" : "auto",
                  transform: `scale(${scale})`, opacity,
                  transition: noTransRef.current ? "none" : "transform 0.55s cubic-bezier(0.22,0.61,0.36,1), opacity 0.55s ease",
                }}
                onClick={() => {
                  if (cameraAnimationRuns) return;
                  const dir = j - center;
                  if (dir === 0) return;
                  prevAiRef.current = j % L;
                  setOffset((o) => o + dir);
                  onSelect(wp);
                }}
              >
                <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div style={{
                    width: isActive ? "16px" : "13px", height: isActive ? "16px" : "13px",
                    borderRadius: "50%",
                    background: isActive ? "#f97316" : "white",
                    boxShadow: isActive ? "0 0 0 6px rgba(249,115,22,0.15)" : "none",
                    flexShrink: 0, transition: "all 0.4s ease",
                  }} />
                  <div style={{
                    position: "absolute", left: "50%", transform: "translateX(-50%)",
                    whiteSpace: "nowrap", textAlign: "center",
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    ...(isActive ? {
                      bottom: "calc(100% + 22px)",
                      color: "#fff", fontSize: "15px", fontWeight: 700,
                      textTransform: "uppercase", letterSpacing: "1.6px",
                    } : {
                      top: "calc(100% + 18px)",
                      color: "white", fontSize: "13px", fontWeight: 400, letterSpacing: "0.2px",
                    }),
                  }}>
                    {(isEnglisch && wp.TitelEn) ? wp.TitelEn : wp.Titel}
                  </div>
                </div>
              </div>
            );
          })}
        </div>}
      </div>
    </div>
  );
}

const WaypointArrows = () => {
  const [subPointActive, setSubpointActive] = useState(false);
  const [subPointClicked, setSubpointClicked] = useState(false);
  const [currentSetId, setCurrentSetId] = useState(() => stateNavigation.waypointSetId);
  const [imageGalleryActive, setImageGalleryActive] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const snapStateWallPush = useSnapshot(stateWallPush);
  // Height of the actually VISIBLE viewport (excludes iOS browser chrome,
  // unlike 100vh) — used as a concrete, animatable px height for the expanded
  // portrait sidebar. top:0+bottom:0 also fixed the iOS overflow but killed
  // the slide-up animation, since top:auto→0 can't be tweened.
  const [visualVH, setVisualVH] = useState(() =>
    window.visualViewport ? window.visualViewport.height : window.innerHeight
  );
  useEffect(() => {
    const vv = window.visualViewport;
    const update = () => setVisualVH(vv ? vv.height : window.innerHeight);
    update();
    (vv || window).addEventListener("resize", update);
    return () => (vv || window).removeEventListener("resize", update);
  }, []);
  const [currentImageGallery, setCurrentImageGallery] = useState([]);
  const [currentImageText, setCurrentImageText] = useState([]);
  const [currentImageTitel, setCurrentImageTitel] = useState([]);
  const [currentImageLink, setCurrentImageLink] = useState([]);
  const [currentImageLinkTitel, setCurrentImageLinkTitel] = useState([]);
  const [currentGalleryIndex, setCurrentGalleryIndex] = useState(0);
  // TTS-Audio des aktuell angezeigten Info-Texts (leer = kein Play-Button).
  // Vorerst nur der Willkommenstext als Test.
  const [currentAudioSrc, setCurrentAudioSrc] = useState("");
  const snapStateNavigation = useSnapshot(stateNavigation);
  const snapStateDevice = useSnapshot(stateDevice);
  const snapStateInArea = useSnapshot(stateInArea);
  const snapSalzabbauTimebar = useSnapshot(salzabbauTimebarState);
  const snapHandelswegeTimebar = useSnapshot(handelswegeTimebarState);
  const snapMenschenTimebar = useSnapshot(menschenTimebarState);
  const snapHolzarbeitTimebar = useSnapshot(holzarbeitTimebarState);
  const snapKlimaTimebar = useSnapshot(klimaTimebarState);
  const [activeIndex, setActiveIndex] = useState(stateNavigation.waypointIndex);
  const [hideImageInGallery, sethideImageInGallery] = useState(false);
  const [activeButton, setActiveButton] = useState("Information");
  const [roomHistory, setRoomHistory] = useState([]); // stack: [{ roomId, waypointId }, ...]

  const snapStateIframeWindow = useSnapshot(stateIframeWindow);
  const snapStateEnglisch = useSnapshot(stateEnglisch);
  const snapStateInAreaRooms = useSnapshot(stateInAreaRooms);
  const [waypointsVariable, setWaypointsVariable] = useState([]);

  const sidebarWidth = 450;

  const filteredWps = waypointsVariable.filter((wp) => wp.Titel && wp.Titel.trim() !== "");
  const filteredActiveIndex = filteredWps.findIndex((wp) => waypointsVariable.indexOf(wp) === activeIndex);

  // Derived directly from the current waypoint — never goes stale, unlike a
  // separately-tracked useState that has to be manually synced at every navigation call site.
  const changeJson = waypointsVariable[activeIndex]?.ChangeJson === true;

  // Narrow smartphone in landscape — portrait already looks right, this only
  // targets the case that otherwise falls through to full desktop sizing.
  const isLandscapeHandy = !snapStateDevice.isPortrait && snapStateDevice.isHandy;

  // True while standing on a MainPoint waypoint that has its own embedded 2D
  // Zeitmaschine slider (SalzabbauTimebar2D etc.) showing — that waypoint IS the
  // timemachine experience itself, so the "enter deeper" up arrow shouldn't show there.
  const anyTimebarActive =
    snapSalzabbauTimebar.areaActive ||
    snapHandelswegeTimebar.areaActive ||
    snapMenschenTimebar.areaActive ||
    snapHolzarbeitTimebar.areaActive ||
    snapKlimaTimebar.areaActive;

  // areaActive above is set by CheckInArea's useEffect, which fires one render
  // after activeIndex changes — so for a single frame changeJson can be true
  // while anyTimebarActive hasn't caught up yet, flashing the up arrow. Suppress
  // it for one frame after every waypoint change so that render never paints.
  const [arrowSettling, setArrowSettling] = useState(false);
  useLayoutEffect(() => {
    setArrowSettling(true);
    const id = requestAnimationFrame(() => setArrowSettling(false));
    return () => cancelAnimationFrame(id);
  }, [activeIndex, currentSetId]);

  // A room is a "Schaustelle" (leaf room, exit allowed from ANY waypoint) only when
  // it has neither a specific exitAreaId nor a downExitAreaId defined.
  const currentRoomConfig = ROOM_CONFIG[currentSetId];
  const isLeafSchaustelle =
    !!currentRoomConfig?.parentId &&
    currentRoomConfig.exitAreaId == null &&
    currentRoomConfig.downExitAreaId == null;

  // Explicit allow-list for the UP arrow instead of relying on the inverse of
  // isLeafSchaustelle — if currentRoomConfig is missing/mismatched (unknown
  // currentSetId), this stays false instead of accidentally defaulting to "show".
  // Top-level rooms (parentId null, e.g. EntryRoom) are allowed through for the
  // entryAreaId-based "enter a theme room" arrow; child rooms need an explicit exitAreaId.
  const hasDefinedUpExit = !!currentRoomConfig && (
    currentRoomConfig.parentId == null || currentRoomConfig.exitAreaId != null
  );

  // Down-arrow shows either: we're in a leaf Schaustelle (anywhere),
  // OR we're standing exactly on this room's designated downExitAreaId waypoint.
  const showDownExit =
    isLeafSchaustelle ||
    (!!currentRoomConfig?.downExitAreaId && currentRoomConfig.downExitAreaId === snapStateInArea.inAreaIndex);

  const applyOrientationOffset = (wp, baseCamPos, baseTargetPos) => {
    const isPortrait = stateDevice.isPortrait;
    const offset = isPortrait ? (wp.CamPortrait ?? 0) : (wp.CamLandscape ?? 0);
    if (offset) {
      const dir = new THREE.Vector3().subVectors(baseCamPos, baseTargetPos).normalize();
      baseCamPos.addScaledVector(dir, offset);
    }
  };

  const initializeNavigation = (wps) => {
    stateNavigation.waypointIndex = 0;
    const wp = wps[0];
    const baseCamPos = new THREE.Vector3(...wp.Cam.Position);
    const baseTargetPos = new THREE.Vector3(...wp.Target.Position);
    applyOrientationOffset(wp, baseCamPos, baseTargetPos);
    stateNavigation.wayCamPos = baseCamPos;
    stateNavigation.wayCamTargetPos = baseTargetPos;
    stateNavigation.waypointId = wp.Id;
    stateInArea.inAreaIndex = wp.Id;
  };

  const switchWaypointSet = async (newSetId) => {
    stateNavigation.cameraAnimationRuns = true; // pre-signal: prevents overlay flash on first render
    const nextData = await loadRoom(newSetId);
    if (!nextData) return;

    setCurrentSetId(newSetId);
    setWaypointsVariable(nextData);
    initializeNavigation(nextData);
    stateNavigation.waypointSetId = newSetId;

    const firstWp = nextData[0];
    if (firstWp) {
      stateNavigation.waypointIndex = 0;
      const baseCamPos = new THREE.Vector3(...firstWp.Cam.Position);
      const baseTargetPos = new THREE.Vector3(...firstWp.Target.Position);
      applyOrientationOffset(firstWp, baseCamPos, baseTargetPos);
      stateNavigation.wayCamPos = baseCamPos;
      stateNavigation.wayCamTargetPos = baseTargetPos;
      stateInArea.inAreaIndex = firstWp.Id;
      stateNavigation.waypointId = firstWp.Id;
      stateNavigation.schaustelleIndex = firstWp.SchaustelleId;
      setActiveIndex(0);
      updateCurrentGalleryFromArchiv(firstWp.IdSearchGallery, firstWp.IdSearchInfo);

      if (firstWp.PhantomPoint && firstWp.PhantomPoint.length > 0) {
        stateNavigation.phantomQueue = firstWp.PhantomPoint;
        stateNavigation.animatingPhantoms = true;
        stateNavigation.pendingWaypoint = firstWp;
      }
    }
  };

  const restoreWaypoint = (roomId, waypointId) => {
    const data = loadedRoomsCache[roomId];
    if (!data) return;
    const wp = data.find((w) => w.Id === waypointId);
    if (!wp) return;

    const baseCamPos = new THREE.Vector3(...wp.Cam.Position);
    const baseTargetPos = new THREE.Vector3(...wp.Target.Position);
    applyOrientationOffset(wp, baseCamPos, baseTargetPos);
    stateNavigation.wayCamPos = baseCamPos;
    stateNavigation.wayCamTargetPos = baseTargetPos;
    stateNavigation.waypointId = wp.Id;
    stateNavigation.waypointIndex = data.findIndex((w) => w.Id === wp.Id);
    stateNavigation.schaustelleIndex = wp.SchaustelleId;
    setActiveIndex(stateNavigation.waypointIndex);
    stateInArea.inAreaIndex = wp.Id;
    updateCurrentGalleryFromArchiv(wp.IdSearchGallery, wp.IdSearchInfo);
  };

  const goToWaypoint = (wp) => {
    stateNavigation.cameraAnimationRuns = true;
    stateNavigation.annotationOverwrite = "";
    const baseCamPos = new THREE.Vector3(...wp.Cam.Position);
    const baseTargetPos = new THREE.Vector3(...wp.Target.Position);
    applyOrientationOffset(wp, baseCamPos, baseTargetPos);
    stateNavigation.wayCamPos = baseCamPos;
    stateNavigation.wayCamTargetPos = baseTargetPos;
    stateInArea.inAreaIndex = wp.Id;
    stateNavigation.waypointId = wp.Id;
    stateNavigation.schaustelleIndex = wp.SchaustelleId;
    setActiveIndex(stateNavigation.waypointIndex);

    updateCurrentGalleryFromArchiv(wp.IdSearchGallery, wp.IdSearchInfo);

    if (currentSetId === "EntryRoom") {
      stateWallPush.activeThemeIndex = -1;
    }
  };

  // Initial load — restores stored room/waypoint when returning from player mode
  useEffect(() => {
    const savedSetId = stateNavigation.waypointSetId;
    const savedWpId = stateNavigation.waypointId;
    (async () => {
      if (savedSetId && savedSetId !== "EntryRoom") {
        await switchWaypointSet(savedSetId);
        if (savedWpId) restoreWaypoint(savedSetId, savedWpId);
      } else {
        const data = await loadRoom("EntryRoom");
        setWaypointsVariable(data);
        initializeNavigation(data);
        const firstWp = data[0];
        if (firstWp) updateCurrentGalleryFromArchiv(firstWp.IdSearchGallery, firstWp.IdSearchInfo);
      }
    })();
  }, []);

  // Annotation_Overwrite
  useEffect(() => {
    if (!waypointsVariable.length) return;

    if (snapStateNavigation.annotationOverwrite !== "") {
      updateCurrentGalleryFromArchiv(snapStateNavigation.annotationOverwrite, snapStateNavigation.annotationOverwrite);
    } else {
      const wp = waypointsVariable[stateNavigation.waypointIndex];
      if (wp) updateCurrentGalleryFromArchiv(wp.IdSearchGallery, wp.IdSearchInfo);
    }
  }, [snapStateNavigation.annotationOverwrite]);

  // Re-run gallery/text lookup when language changes
  useEffect(() => {
    if (!waypointsVariable.length) return;
    if (snapStateNavigation.annotationOverwrite !== "") {
      updateCurrentGalleryFromArchiv(snapStateNavigation.annotationOverwrite, snapStateNavigation.annotationOverwrite);
    } else {
      const wp = waypointsVariable[stateNavigation.waypointIndex];
      if (wp) updateCurrentGalleryFromArchiv(wp.IdSearchGallery, wp.IdSearchInfo);
    }
  }, [snapStateEnglisch.isEnglisch]);

  const handleWaypointForward = () => {
    if (snapStateNavigation.cameraAnimationRuns) return;
    setActiveButton("Information");
    const wps = waypointsVariable;
    if (!wps.length) return;
    const nextIndex = (stateNavigation.waypointIndex + 1) % wps.length;
    stateNavigation.waypointIndex = nextIndex;

    const wp = wps[nextIndex];

    if (wp.PhantomPoint && wp.PhantomPoint.length > 0) {
      stateNavigation.phantomQueue = wp.PhantomPoint;
      stateNavigation.animatingPhantoms = true;
      stateNavigation.pendingWaypoint = wp;
      goToWaypoint(wp);
    } else {
      goToWaypoint(wp);
    }

    if (wp.Subpoints && wp.Subpoints.length > 0) {
      const sub = wp.Subpoints[0];
      stateNavigation.wayCamSubPos = new THREE.Vector3(...sub.Cam.Position);
      stateNavigation.wayCamTargetSubPos = new THREE.Vector3(...sub.Target.Position);
      setSubpointActive(true);
    } else {
      setSubpointActive(false);
    }

    if (currentSetId === "EntryRoom") {
      stateWallPush.activeThemeIndex = -1;
    }
  };

  const handleWaypointBackward = () => {
    stateNavigation.annotationOverwrite = "";
    if (snapStateNavigation.cameraAnimationRuns) return;
    setActiveButton("Information");
    const wps = waypointsVariable;
    if (!wps.length) return;
    const currentIndex = stateNavigation.waypointIndex;
    const prevIndex = (currentIndex - 1 + wps.length) % wps.length;
    const wpCurrent = wps[currentIndex];
    const wpPrev = wps[prevIndex];

    stateNavigation.waypointIndex = prevIndex;

    if (wpPrev.Subpoints && wpPrev.Subpoints.length > 0) {
      const sub = wpPrev.Subpoints[0];
      stateNavigation.wayCamSubPos = new THREE.Vector3(...sub.Cam.Position);
      stateNavigation.wayCamTargetSubPos = new THREE.Vector3(...sub.Target.Position);
      setSubpointActive(true);
    } else {
      setSubpointActive(false);
    }

    updateCurrentGalleryFromArchiv(wpPrev.IdSearchGallery, wpPrev.IdSearchInfo);
    stateInArea.inAreaIndex = wpPrev.Id;
    stateNavigation.waypointId = wpPrev.Id;
    stateNavigation.schaustelleIndex = wpPrev.SchaustelleId;
    setActiveIndex(prevIndex);

    if (wpCurrent.PhantomPoint && wpCurrent.PhantomPoint.length > 0) {
      stateNavigation.phantomQueue = [...wpCurrent.PhantomPoint].reverse();
      stateNavigation.pendingWaypoint = wpPrev;
      stateNavigation.animatingPhantoms = true;
    } else {
      const baseCamPosBack = new THREE.Vector3(...wpPrev.Cam.Position);
      const baseTargetPosBack = new THREE.Vector3(...wpPrev.Target.Position);
      applyOrientationOffset(wpPrev, baseCamPosBack, baseTargetPosBack);
      stateNavigation.wayCamPos = baseCamPosBack;
      stateNavigation.wayCamTargetPos = baseTargetPosBack;
    }

    if (currentSetId === "EntryRoom") {
      stateWallPush.activeThemeIndex = -1;
    }
  };

  // 🧭 Generic, config-driven enter / exit — replaces the old hardcoded if/else chain
  const handleWaypointUp = async () => {
    stateNavigation.annotationOverwrite = "";
    const currentArea = stateInArea.inAreaIndex;

    // 1️⃣ Standing on an ENTRY waypoint into a child room?
    const entryMatch = Object.entries(ROOM_CONFIG).find(
      ([, cfg]) => cfg.entryAreaId === currentArea
    );

    if (entryMatch) {
      const [roomId] = entryMatch;
      setRoomHistory((prev) => [...prev, { roomId: currentSetId, waypointId: stateNavigation.waypointId }]);
      await switchWaypointSet(roomId);
      return;
    }

    // 2️⃣ Are we inside a room, and can we exit from THIS waypoint?
    const currentConfig = ROOM_CONFIG[currentSetId];
    if (currentConfig?.parentId) {
      const matchesUpExit = currentConfig.exitAreaId && currentConfig.exitAreaId === currentArea;
      const matchesDownExit = currentConfig.downExitAreaId && currentConfig.downExitAreaId === currentArea;
      const anywhereExit = currentConfig.exitAreaId == null && currentConfig.downExitAreaId == null;

      if (matchesUpExit || matchesDownExit || anywhereExit) {
        const parentId = currentConfig.parentId;
        const last = roomHistory[roomHistory.length - 1];

        // Capture before switch — waypointsVariable will be overwritten
        const exitingWp = waypointsVariable[stateNavigation.waypointIndex];

        await switchWaypointSet(parentId);

        if (last && last.roomId === parentId) {
          restoreWaypoint(parentId, last.waypointId);
        }

        // Reversed phantom animation on exit (same phantom as entry, played backwards)
        if (exitingWp?.PhantomPoint?.length > 0) {
          const parentData = loadedRoomsCache[parentId];
          const destWpId = last?.roomId === parentId ? last.waypointId : null;
          const destWp = (destWpId ? parentData?.find((w) => w.Id === destWpId) : null)
                       ?? parentData?.[0];
          if (destWp) {
            stateNavigation.phantomQueue = [...exitingWp.PhantomPoint].reverse();
            stateNavigation.pendingWaypoint = destWp;
            stateNavigation.animatingPhantoms = true;
          }
        }

        setRoomHistory((prev) => prev.slice(0, -1));
        return;
      }
    }
  };

  const updateCurrentGalleryFromArchiv = (idGallery, idInfo) => {
    const galleryArchiv = stateEnglisch.isEnglisch ? imageGalleryArchivEn : imageGalleryArchiv;
    const textArchiv = stateEnglisch.isEnglisch ? infoTextArchivEn : infoTextArchiv;

    let match = null;
    let fromInfo = false;

    if (idGallery && idGallery.trim() !== "") {
      match = galleryArchiv.find((item) => item.Id === idGallery);
    }

    if ((!match || !match.Images || match.Images.length === 0) && idInfo && idInfo.trim() !== "") {
      match = textArchiv.find((item) => item.Id === idInfo);
      fromInfo = true;
    }

    if (match) {
      if (fromInfo) {
        const titelArray = [match.Titel];
        const textArray = match.Text || [];
        const linkArray = [match.Link || ""];
        const linkTitelArray = [match.MuseumTitel || ""];

        setCurrentGalleryIndex(0);
        setCurrentImageGallery([]);
        setCurrentImageText(textArray);
        setCurrentImageTitel(titelArray);
        setCurrentImageLink(linkArray);
        setCurrentImageLinkTitel(linkTitelArray);
        setImageGalleryActive(false);
        setCurrentAudioSrc(TTS_AUDIO_BY_INFO_ID[match.Id] || "");
      } else if (match.Images && match.Images.length > 0) {
        const galleryArray = match.Images.map((img) => img.Pic);
        const textArray = match.Images.map((img) => img.Text);
        const titelArray = match.Images.map((img) => img.Title);
        const linkArray = match.Images.map((img) => img.Link);
        const linkTitelArray = match.Images.map((img) => img.LinkTitel);

        sethideImageInGallery(match?.Images?.[0]?.hideImageInGallery === true);

        setCurrentImageGallery(galleryArray);
        setCurrentImageText(textArray);
        setCurrentImageTitel(titelArray);
        setCurrentImageLink(linkArray);
        setCurrentImageLinkTitel(linkTitelArray);
        setCurrentGalleryIndex(0);
        setImageGalleryActive(true);
        setCurrentAudioSrc("");
      }
    } else {
      setCurrentGalleryIndex(0);
      setImageGalleryActive(false);
      setCurrentImageGallery([]);
      setCurrentImageText([]);
      setCurrentImageTitel([]);
      setCurrentImageLink([]);
      setCurrentImageLinkTitel([]);
      setCurrentAudioSrc("");
    }
  };

  const handleSubpointClick = () => {
    if (subPointClicked) {
      setSubpointClicked(false);
      stateNavigation.wayPointSubClicked = false;
    } else {
      setSubpointClicked(true);
      stateNavigation.wayPointSubClicked = true;
    }
  };

  const handleWaypointListSelect = (wp, index) => {
    if (snapStateNavigation.cameraAnimationRuns) return;
    stateNavigation.waypointIndex = index;
    stateNavigation.annotationOverwrite = "";
    if (wp.PhantomPoint && wp.PhantomPoint.length > 0) {
      stateNavigation.phantomQueue = wp.PhantomPoint;
      stateNavigation.animatingPhantoms = true;
      stateNavigation.pendingWaypoint = wp;
    }
    goToWaypoint(wp);
    if (wp.Subpoints && wp.Subpoints.length > 0) {
      const sub = wp.Subpoints[0];
      stateNavigation.wayCamSubPos = new THREE.Vector3(...sub.Cam.Position);
      stateNavigation.wayCamTargetSubPos = new THREE.Vector3(...sub.Target.Position);
      setSubpointActive(true);
    } else {
      setSubpointActive(false);
    }
    stateNavigation.waypointListOpen = false;
  };

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
    stateNavigation.slideBarActive = !sidebarOpen;
  };

  const handleToggle = (name) => {
    setActiveButton(name);
    if (activeButton === "MuseumTemp") {
      setActiveButton("Logo");
    }
  };

  const handleHomepageButton = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    if (!sidebarOpen && activeButton === "Salzzeitmussen") {
      setActiveButton("Information");
    }
  }, [sidebarOpen]);

  useEffect(() => {
    if (snapStateDevice.isPortrait) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(true);
    }
  }, [snapStateDevice.isPortrait]);

  const isMDR = currentSetId === "ThemeM_MuseenDerRegion";
  const isMDROverlay = isMDR && !snapStateNavigation.cameraAnimationRuns;

  const DOOR_INDEX_MAP = {
    ThemeM_MuseenDerRegion: 0,
    ThemeM_Holzarbeit: 1,
    ThemeM_Klima: 2,
    ThemeM_Salzabbau: 3,
    ThemeM_Handelswege: 4,
    ThemeM_Menschen: 5,
  };

  const currentWp = waypointsVariable[activeIndex];
  const currentWpId = currentWp?.Id;
  const videoFallbackTitle = currentWpId?.toLowerCase().includes('video')
    ? (snapStateEnglisch.isEnglisch && currentWp?.TitelEn ? currentWp.TitelEn : currentWp?.Titel) ?? null
    : null;
  const currentDoorIndex = DOOR_INDEX_MAP[currentWpId] ?? -1;

  const handleDoorIconClick = () => {
    if (currentDoorIndex === -1) return;
    stateWallPush.activeThemeIndex = currentDoorIndex;
  };

  // When in MDR, collapse the sidebar for Experience.jsx so the canvas uses full width.
  useEffect(() => {
    stateNavigation.slideBarActive = isMDR ? false : sidebarOpen;
  }, [isMDR, sidebarOpen]);

  return (
    <>
      {!isMDR && <div
        className="fixed top-0  h-full px-8 flex justify-center items-center  py-4  z-[10] transition-all pointer-events-none"
        style={{
          /* Nur im Landscape/Desktop neben die Sidebar quetschen — im Portrait
             ist sidebarWidth (450px) breiter als der Screen, calc() würde
             negativ und die Header-Buttons springen beim Expandieren nach links. */
          width: !snapStateDevice.isPortrait && sidebarOpen ? `calc(100% - ${snapStateNavigation.sidebarWidth}px)` : "98%",
        }}
      >
        <Header
          waypointsVariable={waypointsVariable}
          onSelectWaypoint={handleWaypointListSelect}
          activeIndex={activeIndex}
          isEnglisch={snapStateEnglisch.isEnglisch}
        />
      </div>}
      {currentSetId === "EntryRoom" && changeJson && currentDoorIndex !== -1 &&
        snapStateInAreaRooms.inAreaRoomEntryRoom && !snapStateNavigation.cameraAnimationRuns &&
        snapStateWallPush.activeThemeIndex !== currentDoorIndex && (
        <div
          className="fixed z-[5] pointer-events-auto"
          style={{
            /* Wie beim Header: im Portrait ist sidebarWidth (450px) breiter
               als der Screen, calc() würde negativ und die Tür-Icon springt
               beim Sidebar-Expandieren nach links. */
            left: !snapStateDevice.isPortrait && sidebarOpen ? `calc((100% - ${snapStateNavigation.sidebarWidth}px) / 2)` : "50%",
            top: snapStateDevice.isPortrait ? "30%" : "50%",
            transform: "translate(-50%, -50%)",
          }}
          onClick={handleDoorIconClick}
        >
          <div className={`flex items-center justify-center rounded-full cursor-pointer border-2 bg-black/30 border-white/30 hover:bg-black/50 hover:border-white/60 transition-all duration-300
            ${snapStateDevice.isPortrait || snapStateDevice.isHandy ? "w-24 h-24" : "w-40 h-40"}`}>
            <div className="animate-blink-orange"><BsFillDoorOpenFill size={snapStateDevice.isPortrait || snapStateDevice.isHandy ? 40 : 68} /></div>
          </div>
        </div>
      )}

      {snapStateNavigation.annotationOverwrite !== "" && !hideImageInGallery && !snapStateIframeWindow.LowModelOrbit && !isMDR && (
        <div
          className={`fixed flex flex-col bg-black/80 backdrop-blur-md z-[50] transition-all ${
            snapStateDevice.isPortrait ? "left-0 w-full" : "top-0 h-full"
          }`}
          style={{
            width: !snapStateDevice.isPortrait
              ? sidebarOpen
                ? `calc(100% - ${snapStateNavigation.sidebarWidth}px)`
                : "99%"
              : "100%",
            /* Konstante Höhe: vorher kollabierte die Galerie beim Sidebar-
               Expandieren auf 0vh (transition-all → sichtbares Springen).
               Jetzt bleibt sie stehen und die Sidebar legt sich per zIndex
               einfach drüber.
               iOS: oben verankern statt bottom:33vh — vh ist auf echten
               iPhones die GROSSE Viewport-Höhe, bottom-Verankerung schob
               die Oberkante (und das X) über den sichtbaren Bereich hinaus.
               Höhe = sichtbare Höhe (visualVH) minus 33vh-Sidebar-Streifen. */
            top: snapStateDevice.isPortrait ? 0 : undefined,
            height: snapStateDevice.isPortrait ? `calc(${visualVH}px - 33vh)` : "100vh",
            bottom: snapStateDevice.isPortrait ? undefined : "auto",
          }}
        >
          {/* Eigene Zeile über dem Imageviewer statt absolute Überlagerung —
              das X soll vertikal zuerst kommen, nicht auf dem Bild liegen. */}
          <div className="shrink-0 flex justify-end px-4 pt-3">
            <button
              className="text-white text-2xl hover:text-lime-500 transition"
              onClick={() => (stateNavigation.annotationOverwrite = "")}
            >
              ✕
            </button>
          </div>
          <div className="flex-1 min-h-0 flex justify-center items-center pb-4">
            <SlidebarImageGalleryBig currentGalerie={currentImageGallery} currentIndex={currentGalleryIndex} onIndexChange={setCurrentGalleryIndex} />
          </div>
        </div>
      )}

      {!snapStateIframeWindow.LowModelOrbit && !isMDR && (
        <div
          className="fixed bottom-0 w-full z-10 py-4 flex justify-center
  mobilePortrait:bottom-55"
          style={{
            left: 0,
            bottom: snapStateDevice.isPortrait ? "33vh" : "0",
            /* Wie beim Header/Tür-Icon: im Portrait ist sidebarWidth (450px)
               breiter als der Screen, calc() würde negativ und die
               Vor/Zurück-Pfeile springen beim Sidebar-Expandieren nach links. */
            width: !snapStateDevice.isPortrait && sidebarOpen ? `calc(100% - ${snapStateNavigation.sidebarWidth}px)` : "100%",
            background: "linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 100%)",
          }}
        >
          <div className="relative flex items-center w-full mx-10 justify-between">
            <div
              className={`flex-shrink-0 rounded-full cursor-pointer z-20 flex items-center justify-center transition-colors duration-200 bg-black/30 border border-white/[0.14] hover:bg-black/50 hover:border-white/30 active:scale-95 ${snapStateDevice.isPortrait ? "w-[52px] h-[52px]" : isLandscapeHandy ? "w-11 h-11" : "w-[58px] h-[58px]"}`}
              onClick={handleWaypointBackward}
            >
              <BsChevronLeft
                size={snapStateDevice.isPortrait ? 21 : isLandscapeHandy ? 18 : 22}
                color={snapStateNavigation.cameraAnimationRuns ? "#444" : "#e2e2e2"}
              />
            </div>

            <div className="flex-1 relative flex items-center mx-10">
              {!snapStateDevice.isPortrait && !isLandscapeHandy ? (
                <LandscapeCarousel
                  filteredWps={filteredWps}
                  filteredActiveIndex={filteredActiveIndex}
                  waypointsVariable={waypointsVariable}
                  cameraAnimationRuns={snapStateNavigation.cameraAnimationRuns}
                  isEnglisch={snapStateEnglisch.isEnglisch}
                  onSelect={(wp) => {
                    if (snapStateNavigation.cameraAnimationRuns) return;
                    setActiveButton("Information");
                    const fullIndex = waypointsVariable.indexOf(wp);
                    stateNavigation.waypointIndex = fullIndex;
                    setActiveIndex(fullIndex);
                    stateNavigation.waypointId = wp.Id;
                    stateInArea.inAreaIndex = wp.Id;
                    stateNavigation.schaustelleIndex = wp.SchaustelleId;
                    const fwdCamPos = new THREE.Vector3(...wp.Cam.Position);
                    const fwdTargetPos = new THREE.Vector3(...wp.Target.Position);
                    applyOrientationOffset(wp, fwdCamPos, fwdTargetPos);
                    stateNavigation.wayCamPos = fwdCamPos;
                    stateNavigation.wayCamTargetPos = fwdTargetPos;
                    updateCurrentGalleryFromArchiv(wp.IdSearchGallery, wp.IdSearchInfo);
                  }}
                />
              ) : (
                // ── Portrait: sliding dot carousel + current label ──
                <div className="w-full flex flex-col items-center gap-2">
                  <div className="font-roboto text-[11px] text-white uppercase tracking-wide text-center">
                    {(() => { const wp = waypointsVariable[stateNavigation.waypointIndex]; return (snapStateEnglisch.isEnglisch && wp?.TitelEn) ? wp.TitelEn : wp?.Titel; })()}
                  </div>
                  {/* viewport: 5 slots × 28px each = 140px */}
                  <div
                    style={{
                      width: "140px",
                      overflow: "hidden",
                      maskImage: "linear-gradient(to right, transparent 0%, black 18%, black 82%, transparent 100%)",
                      WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 18%, black 82%, transparent 100%)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "12px",
                        transition: "transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
                        transform: `translateX(${62 - filteredActiveIndex * 28}px)`,
                      }}
                    >
                      {filteredWps.map((wp, index) => {
                        const distance = Math.abs(index - filteredActiveIndex);
                        const isActive = distance === 0;
                        const fullIndex = waypointsVariable.indexOf(wp);
                        return (
                          <div
                            /* fullIndex statt wp.Id: manche Waypoint-Sets (z.B.
                               waypointsSalzent.json) haben zwei verschiedene
                               Einträge mit absichtlich derselben Id (geteilte
                               Orbit-Cam-Position + Info-Text) — die Id allein
                               ist also nicht garantiert eindeutig. */
                            key={`portrait-dot-${fullIndex}-${wp.Id}`}
                            style={{ width: "16px", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}
                            className="cursor-pointer"
                            onClick={() => {
                              if (snapStateNavigation.cameraAnimationRuns) return;
                              setActiveButton("Information");
                              stateNavigation.waypointIndex = fullIndex;
                              setActiveIndex(fullIndex);
                              stateNavigation.waypointId = wp.Id;
                              stateInArea.inAreaIndex = wp.Id;
                              stateNavigation.schaustelleIndex = wp.SchaustelleId;
                              const dotCamPos = new THREE.Vector3(...wp.Cam.Position);
                              const dotTargetPos = new THREE.Vector3(...wp.Target.Position);
                              applyOrientationOffset(wp, dotCamPos, dotTargetPos);
                              stateNavigation.wayCamPos = dotCamPos;
                              stateNavigation.wayCamTargetPos = dotTargetPos;
                              updateCurrentGalleryFromArchiv(wp.IdSearchGallery, wp.IdSearchInfo);
                            }}
                          >
                            <div
                              className="rounded-full transition-all duration-350"
                              style={{
                                backgroundColor: isActive ? "#f97316" : "white",
                                width: isActive ? "14px" : distance === 1 ? "9px" : distance === 2 ? "6px" : "5px",
                                height: isActive ? "14px" : distance === 1 ? "9px" : distance === 2 ? "6px" : "5px",
                                opacity: isActive ? 1 : distance === 1 ? 0.6 : distance === 2 ? 0.35 : 0.15,
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}

              {changeJson === true && (currentSetId !== "EntryRoom" || snapStateWallPush.activeThemeIndex !== -1) && hasDefinedUpExit &&
                !anyTimebarActive && !arrowSettling &&
                !snapStateNavigation.cameraAnimationRuns && (
                  <div
                    className={`absolute left-1/2 transform -translate-x-1/2 rounded-full cursor-pointer z-30 flex items-center justify-center transition-colors duration-200 bg-black/30 border border-white/[0.2] hover:bg-black/50
                      ${snapStateDevice.isPortrait || snapStateDevice.isHandy ? "top-[-65px] w-[57px] h-[57px]" : "top-[-150px] w-[75px] h-[75px]"}`}
                    onClick={handleWaypointUp}
                  >
                    <TbArrowBarToUp size={snapStateDevice.isPortrait || snapStateDevice.isHandy ? 23 : 29} className="animate-blink-orange" />
                  </div>
                )}

              {showDownExit && (
                <div
                  className={`absolute left-1/2 transform -translate-x-1/2 rounded-full cursor-pointer z-30 flex items-center justify-center transition-colors duration-200 bg-black/30 border border-white/[0.2] hover:bg-black/50
                    ${snapStateDevice.isPortrait || snapStateDevice.isHandy ? "top-[-65px] w-[57px] h-[57px]" : "top-[-120px] w-[75px] h-[75px]"}`}
                  onClick={handleWaypointUp}
                >
                  <TbArrowBarToDown size={snapStateDevice.isPortrait || snapStateDevice.isHandy ? 23 : 29} className="animate-blink-orange" />
                </div>
              )}
            </div>

            <div
              className={`flex-shrink-0 rounded-full cursor-pointer z-20 flex items-center justify-center transition-colors duration-200 bg-black/30 border border-white/[0.14] hover:bg-black/50 hover:border-white/30 active:scale-95 ${snapStateDevice.isPortrait ? "w-[52px] h-[52px]" : isLandscapeHandy ? "w-11 h-11" : "w-[58px] h-[58px]"}`}
              onClick={handleWaypointForward}
            >
              <BsChevronRight
                size={snapStateDevice.isPortrait ? 21 : isLandscapeHandy ? 18 : 22}
                color={snapStateNavigation.cameraAnimationRuns ? "#444" : "#e2e2e2"}
              />
            </div>
          </div>
        </div>
      )}

      {isMDROverlay && (
        <div className="fixed inset-0 z-[100] pointer-events-auto">
          <SalzzeitMuseen onClose={handleWaypointUp} mdrMode={true} />
        </div>
      )}

      {!isMDR && <div
        className={`
    fixed bg-zinc-900 transition-all duration-500 z-[60]
    right-0 top-0 h-screen overflow-hidden
    mobilePortrait:left-0 mobilePortrait:right-0 mobilePortrait:top-auto mobilePortrait:bottom-0 mobilePortrait:w-screen
    ${sidebarOpen ? "" : "mobilePortrait:h-[33vh]"}
  `}
        style={{
          width: !snapStateDevice.isPortrait ? (sidebarOpen ? `${snapStateNavigation.sidebarWidth}px` : "20px") : "100%",
          /* Expanded portrait: concrete px height of the VISIBLE viewport
             (visualViewport) — fills the screen on real iPhones where 100vh
             overflowed past the top (iOS's 100vh includes the collapsed
             browser chrome), while staying a tweenable height so the sidebar
             still animates up/down. Collapsed keeps the original h-[33vh]
             class untouched — the canvas height in Experience.jsx is computed
             against that strip, so changing it would open a gap.
             Landscape-Handy: gleiche vh-Falle in die andere Richtung —
             h-screen (100vh = große Viewport-Höhe) ragt auf echten Phones
             unten raus und schneidet die mt-auto-Buttons ab; deshalb auch
             hier die sichtbare Höhe in px. */
          height: snapStateDevice.isPortrait
            ? (sidebarOpen ? `${visualVH}px` : undefined)
            : isLandscapeHandy
              ? `${visualVH}px`
              : undefined,
        }}
      >
        {activeButton === "Salzzeitmussen" && (
          <SalzzeitMuseen onClose={() => setActiveButton("Information")} />
        )}
        <div className="flex flex-col h-full overflow-hidden">
          {snapHolzarbeitTimebar.areaActive && holzarbeitZeitmaschineTexte[snapHolzarbeitTimebar.splinePoint] && (
            <div className="px-5 pt-5 pb-2 flex-shrink-0">
              {holzarbeitZeitmaschineTitel[snapHolzarbeitTimebar.splinePoint] && (
                <p className="font-roboto font-normal text-sm leading-6 tracking-wide uppercase text-white mobilePortrait:text-center">
                  {snapStateEnglisch.isEnglisch
                    ? holzarbeitZeitmaschineTitel[snapHolzarbeitTimebar.splinePoint].en
                    : holzarbeitZeitmaschineTitel[snapHolzarbeitTimebar.splinePoint].de}
                </p>
              )}
              <p className="font-roboto font-light text-sm leading-6 tracking-wide text-white">
                {snapStateEnglisch.isEnglisch
                  ? holzarbeitZeitmaschineTexte[snapHolzarbeitTimebar.splinePoint].en
                  : holzarbeitZeitmaschineTexte[snapHolzarbeitTimebar.splinePoint].de}
              </p>
            </div>
          )}
          <div className="flex-1 overflow-hidden ">
            <SlidebarImageGallery
              hideImageInGallery={hideImageInGallery}
              imageGalleryActive={imageGalleryActive}
              currentImageTitel={currentImageTitel}
              currentImageLink={currentImageLink}
              currentImageLinkTitel={currentImageLinkTitel}
              currentGalerie={currentImageGallery}
              currentText={currentImageText}
              sidebarOpen={sidebarOpen}
              currentIndex={currentGalleryIndex}
              onIndexChange={setCurrentGalleryIndex}
              videoFallbackTitle={videoFallbackTitle}
              audioSrc={currentAudioSrc}
            />
          </div>

          <div
            className={`absolute left-[-15px] top-1/2 transform -translate-y-1/2 bg-black cursor-pointer z-50 hover:bg-lime-500 transition-colors
                 ${isLandscapeHandy ? "w-8 p-2" : "w-10 p-3"}
                 mobilePortrait:left-1/2
                 mobilePortrait:top-[0px]
                 mobilePortrait:h-2
                 mobilePortrait:pt-2
                 mobilePortrait:pb-2.5
                 mobilePortrait:flex
                 mobilePortrait:-translate-x-1/2 mobilePortrait:translate-y-0
                 mobilePortrait:items-center mobilePortrait:justify-center`}
            onClick={toggleSidebar}
          >
            {sidebarOpen ? (
              <BsChevronRight size={snapStateDevice.isPortrait || isLandscapeHandy ? 20 : 30} className="text-white mobilePortrait:rotate-90 z-500" />
            ) : (
              <BsChevronLeft size={snapStateDevice.isPortrait || isLandscapeHandy ? 20 : 30} className="text-white mobilePortrait:rotate-90 z-500" />
            )}
          </div>

          {activeButton === "MuseumLink" ? (
            <div onClick={() => handleHomepageButton(currentImageLink)} className="flex flex-col items-center justify-center h-full w-full">
              {" "}
              <TbChevronsUpRight
                size={200}
                color="#fc8207"
                className=" animate-pulse object-contain  h-[30vh]  transform hover:scale-105 hover:rounded-xl duration-200 "
              />
              <p className="font-roboto font-light px-3 mb- mt-0 text-ms  leading-5 tracking-wide text-center text-white lg:text-left">
                {currentImageLinkTitel}
              </p>
            </div>
          ) : null}

          {sidebarOpen && activeButton != "Salzzeitmussen" && (
            <div
              /* md:/lg: nur außerhalb Landscape-Handy — ein 844px-Handy erfüllt
                 md: (min-width 768px), wodurch die Desktop-Abstände die
                 Kompakt-Klassen bisher überschrieben haben. */
              className={`mt-auto w-full flex flex-col items-center
${isLandscapeHandy
  ? "px-3 pb-1.5 space-y-1"
  : "px-5 pb-3 space-y-2 md:pb-5 md:space-y-3 lg:pb-5 lg:space-y-3"}
`}
            >
              <button
                className={`w-full font-roboto font-light text-center text-white bg-zinc-800 border hover:border-lime-500 transition-colors
    ${isLandscapeHandy ? "p-0.5 px-2 text-[11px]" : "p-1.5 px-4 text-sm"}
    ${activeButton === "Information" ? "border-lime-500" : "border-zinc-600"}`}
                onClick={() => handleToggle("Information")}
              >
                Live Information
              </button>
              {currentImageLinkTitel[0] && currentImageLinkTitel[0] != "" && (
                <button
                  className={`w-full font-roboto font-light text-center text-white bg-zinc-800 border hover:border-lime-500 transition-colors
     ${isLandscapeHandy ? "p-0.5 px-2 text-[11px]" : "p-1.5 px-4 text-sm"}
     ${activeButton === "MuseumLink" ? "border-lime-500" : "border-zinc-600"}`}
                  onClick={() => handleToggle("MuseumLink")}
                >
                  {snapStateEnglisch.isEnglisch ? "on display at" : "zu sehen in"} {currentImageLinkTitel[0]}
                </button>
              )}

              <button
                className={`w-full font-roboto font-light text-center text-white bg-zinc-800 border hover:border-lime-500 transition-colors
     ${isLandscapeHandy ? "p-0.5 px-2 text-[11px]" : "p-1.5 px-4 text-sm"}
     ${activeIndex === "Gallery" ? "border-lime-500" : "border-zinc-600"}`}
                onClick={() => handleToggle("Salzzeitmussen")}
              >
                {snapStateEnglisch.isEnglisch ? "The Salzzeit Museums" : "Die Salzzeitmuseen"}
              </button>
            </div>
          )}
        </div>
      </div>}
    </>
  );
};

export default WaypointArrows;
